var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.368 1.13206C13.2107 1.97481 13.2107 3.34314 12.368 4.18588L4.39377 12.1603C4.04943 12.5046 3.61448 12.7493 3.14328 12.8671L0.669467 13.4833C0.270758 13.583 -0.082643 13.2205 0.0170343 12.8308L0.633221 10.357C0.751022 9.88575 0.995684 9.45079 1.34002 9.10644L9.31421 1.13206C10.1569 0.289313 11.5252 0.289313 12.368 1.13206ZM8.55303 3.42469L2.11026 9.86763C1.90184 10.076 1.75686 10.3388 1.68436 10.6198L1.28565 12.2237L2.88955 11.825C3.17046 11.7525 3.43325 11.6075 3.64166 11.3991L10.0844 4.95614L8.5621 3.43376L8.55303 3.42469ZM10.0754 1.90231L9.31421 2.6635L10.8365 4.18588L11.5977 3.42469C12.0236 2.99879 12.0236 2.31915 11.5977 1.90231C11.1718 1.47641 10.4922 1.47641 10.0754 1.90231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.e840bb0cf67249af8e3eb7160b756a24.svg";
export { ForwardRef as ReactComponent };